import { render, staticRenderFns } from "./Resourcesd.vue?vue&type=template&id=081dbd0d&scoped=true&"
import script from "./Resourcesd.vue?vue&type=script&lang=js&"
export * from "./Resourcesd.vue?vue&type=script&lang=js&"
import style0 from "./Resourcesd.vue?vue&type=style&index=0&id=081dbd0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081dbd0d",
  null
  
)

export default component.exports